import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { getEstudo, setEstudo, clearEstudo } from "@/lib/estudo";
import { Target, Landmark, ArrowRight, X, GraduationCap } from "lucide-react";

const fmt = (n) => Number(n || 0).toLocaleString("pt-BR");
const COLORS = {
  CEBRASPE: "border-emerald-500/40 from-emerald-500/15",
  CESGRANRIO: "border-blue-500/40 from-blue-500/15",
};

// "Quero estudar para" — lista dinâmica de concursos REAIS do banco,
// agrupada por banca. Ao escolher, aplica banca+concurso como filtro global.
export const EstudarPara = () => {
  const navigate = useNavigate();
  const [grupos, setGrupos] = useState([]);
  const [sel, setSel] = useState(getEstudo());

  useEffect(() => {
    api.get("/concursos").then((r) => setGrupos(r.data.grupos || [])).catch(() => {});
    const h = () => setSel(getEstudo());
    window.addEventListener("vc-estudo", h);
    return () => window.removeEventListener("vc-estudo", h);
  }, []);

  const choose = (banca, concurso, label) => { setEstudo({ banca, concurso, label }); navigate("/questoes"); };
  const active = sel.banca !== "Todas" || sel.concurso !== "Todas";

  return (
    <div data-testid="estudar-para">
      <div className="mb-3 flex items-center justify-between">
        <h2 className="flex items-center gap-2 text-lg font-bold text-white"><Target className="h-5 w-5 text-emerald-400" /> Quero estudar para</h2>
        {active && (
          <button onClick={clearEstudo} data-testid="estudar-limpar" className="flex items-center gap-1 rounded-full bg-slate-800 px-3 py-1 text-xs font-semibold text-slate-300 hover:bg-slate-700">
            <X className="h-3 w-3" /> Limpar seleção
          </button>
        )}
      </div>

      {active && (
        <div data-testid="estudar-ativo" className="mb-3 rounded-xl border border-emerald-500/30 bg-emerald-500/5 px-4 py-2.5 text-sm text-emerald-300">
          Estudando para: <b>{sel.label || `${sel.banca}${sel.concurso !== "Todas" ? " · " + sel.concurso : ""}`}</b> — aplicado em Questões, Simulados, Incidência, Mapas e Plano.
        </div>
      )}

      <div className="grid gap-4 md:grid-cols-2">
        {grupos.map((g) => (
          <div key={g.banca} className={`rounded-2xl border bg-gradient-to-br to-transparent p-4 ${COLORS[g.banca] || "border-slate-700 from-slate-800"}`}>
            <div className="mb-3 flex items-center justify-between">
              <span className="flex items-center gap-2 font-extrabold text-white"><Landmark className="h-4 w-4" /> {g.banca}</span>
              <span className="font-mono-stats text-xs text-emerald-300">{fmt(g.total)} questões</span>
            </div>
            <button onClick={() => choose(g.banca, "Todas", `Tudo de ${g.banca}`)} data-testid={`estudar-tudo-${g.banca.toLowerCase()}`}
              className="mb-2 flex w-full items-center justify-between rounded-xl border border-slate-700 bg-slate-900/70 px-3 py-2.5 text-left text-sm font-bold text-white transition-colors hover:border-emerald-500/50">
              <span className="flex items-center gap-2"><GraduationCap className="h-4 w-4 text-emerald-400" /> Estudar tudo de {g.banca}</span>
              <ArrowRight className="h-4 w-4 text-slate-400" />
            </button>
            {g.concursos.length > 0 ? (
              <select
                defaultValue=""
                onChange={(e) => {
                  const concurso = e.target.value;
                  if (!concurso) return;
                  const item = g.concursos.find((c) => c.concurso === concurso);
                  choose(g.banca, concurso, `${item?.concurso || concurso} · ${g.banca}`);
                }}
                className="w-full rounded-xl border border-slate-700 bg-slate-900 px-3 py-2.5 text-sm text-slate-200 outline-none transition-colors focus:border-emerald-500/50"
                aria-label={`Selecionar concurso ${g.banca}`}
              >
                <option value="">Selecionar concurso...</option>
                {g.concursos.map((c) => (
                  <option key={c.concurso} value={c.concurso}>
                    {c.concurso} — {fmt(c.count)} questões
                  </option>
                ))}
              </select>
            ) : (
              <p className="rounded-lg bg-slate-900/50 px-3 py-2 text-[11px] text-slate-500">
                Concursos específicos aparecerão aqui conforme as questões forem classificadas por órgão.
              </p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
